import * as React from "react";
import { DayPickerStrings, firstDayOfWeek } from "../../config/dateSettings";
import { InputProps } from "../../interfaces/props/InputProps";
// import * as lcid from "lcid";
import * as lcid from "../../../../utilities/lcid/lcid";
import { logger } from "../../../../utilities/logger";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { clearButtonClass } from "../../config/controlStyles";
import { DatePicker, IButtonProps, IButtonStyles, IconButton, IDatePickerStyles, IIconProps, ITextFieldStyles } from "@fluentui/react";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";
import { DateService } from "../../services/dateService";

const datePickerStyles: Partial<IDatePickerStyles> = { icon: { left: "4px", right: "unset" } };
const textFieldStyles: Partial<ITextFieldStyles> = { suffix: { padding: "0 4px" }, field: { paddingLeft: "34px" } };
const iconButtonStyles: Partial<IButtonStyles> = { root: { height: 'auto' }, icon: { fontSize: '12px' } };
const iconButtonProps: IIconProps = { iconName: 'Clear' };
const clearButtonProps: IButtonProps = { ariaLabel: 'Clear text' };

export const DateOnly: React.FunctionComponent<InputProps> = ({
  displayName,
  isRequired,
  inputValue,
  error,
  inputValidator,
  updateInputValidationStatus,
  regionalSetting
}: InputProps) => {
  const [dateFormat] = React.useState<Intl.DateTimeFormat>(new Intl.DateTimeFormat(lcid.from(regionalSetting?.CollationLCID).replace("_", "-")));
  const languageStrings = React.useContext(LanguageContext);
  const isFirstRun = React.useRef(true);

  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "dateOnly.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const onSelectDate = (date: Date | null | undefined): void => {
    updateInputValidationStatus(inputValidator.validate(date));
  };

  const onFormatDate = React.useCallback((date?: Date): string => {
    return !date || date?.getTime() !== date?.getTime() ? '' : dateFormat.format(date);
  }, [dateFormat]);

  const onClearClick = (ev: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (!ev.defaultPrevented) {
      onSelectDate(undefined);
      ev.stopPropagation();
      ev.preventDefault();
    }
  };

  return (
    <DatePicker
      label={displayName}
      disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
      isRequired={isRequired()}
      allowTextInput
      parseDateFromString={DateService.parseDateFromString}
      firstDayOfWeek={firstDayOfWeek}
      strings={DayPickerStrings}
      value={inputValue?.value}
      placeholder={languageStrings.EnterDate}
      ariaLabel={languageStrings.EnterDate}
      showMonthPickerAsOverlay={true}
      onSelectDate={onSelectDate}
      formatDate={onFormatDate}
      className="xb-sp-input"
      textField={{
        errorMessage: error,
        onRenderSuffix: () => {
          return (
            <div className={clearButtonClass}>
              <IconButton
                styles={iconButtonStyles}
                iconProps={iconButtonProps}
                {...clearButtonProps}
                onClick={onClearClick}
              />
            </div>)
        },
        styles: textFieldStyles
      }}
      styles={datePickerStyles}
    />
  );
};

export default React.memo(DateOnly);
